module.exports = __webpack_public_path__ + "img/top5_img2.7f44f778.png";